<button
  [attr.data-theme]="theme()"
  [attr.data-color]="currentColor()"
  [attr.data-rounded]="currentRounded()"
  [attr.data-variant]="variant()"
  class="flex overflow-hidden divide-x"
>
  <ng-content />
</button>
